'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Editor component jsx file
// @auth: spc@data.me 2017/10/10

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = require('draft-js');

var _ToolBar = require('../ToolBar');

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _Link = require('../../decorators/Link');

var _Link2 = _interopRequireDefault(_Link);

var _blocks = require('../../blocks');

var _blocks2 = _interopRequireDefault(_blocks);

var _utils = require('../../utils');

require('../../Draft.css');

require('./styles.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftEditor = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(DraftEditor, _Component);

    function DraftEditor(props) {
        (0, _classCallCheck3.default)(this, DraftEditor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DraftEditor.__proto__ || (0, _getPrototypeOf2.default)(DraftEditor)).call(this, props));

        _this.onChange = function (editorState) {
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
            }
            if ((0, _utils.getCurrentBlock)(editorState).getKey() !== (0, _utils.getCurrentBlock)(_this.state.editorState).getKey()) {
                _this.setState({
                    editorState: _draftJs.EditorState.forceSelection(editorState, editorState.getSelection())
                });
            } else {
                _this.setState({
                    editorState: editorState
                });
            }
        };

        _this.onTab = function (event) {
            var editorState = _draftJs.RichUtils.onTab(event, _this.state.editorState, 4);
            if (editorState) {
                _this.onChange(editorState);
                event.preventDefault();
            }
        };

        _this.getEditorState = function () {
            return _this.state.editorState;
        };

        _this.createEditorState = function () {
            var decorator = new _draftJs.CompositeDecorator([_Link2.default]);
            if (_this.props.initContentState) {
                return _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(_this.props.initContentState), decorator);
            }
            return _draftJs.EditorState.createEmpty(decorator);
        };

        _this.handleReturn = function (event) {
            var editorState = _this.state.editorState;

            if (!event.altKey && !event.metaKey && !event.ctrlKey) {
                var currentBlock = (0, _utils.getCurrentBlock)(editorState);
                var blockType = currentBlock.getType();
                var blockDepth = currentBlock.getDepth();
                if (blockType === 'atomic') {
                    return 'handled';
                }
                if (currentBlock.getLength() === 0) {
                    switch (blockType) {
                        case 'unordered-list-item':
                        case 'ordered-list-item':
                            if (blockDepth > 0) {
                                var newBlock = currentBlock.set('depth', blockDepth - 1);
                                var contentState = editorState.getCurrentContent();
                                var blockMap = contentState.getBlockMap().set(newBlock.getKey(), newBlock);
                                var selection = editorState.getSelection();
                                var newContentState = contentState.merge({
                                    blockMap: blockMap,
                                    selectionBefore: selection,
                                    selectionAfter: selection
                                });
                                _this.onChange(_draftJs.EditorState.push(editorState, newContentState, 'adjust-depth'));
                            } else {
                                _this.onChange(_draftJs.RichUtils.toggleBlockType(editorState, 'unstyled'));
                            }
                            return 'handled';
                        case 'header-three':
                            _this.onChange(_draftJs.RichUtils.toggleBlockType(editorState, 'unstyled'));
                            return 'handled';
                        default:
                            return 'not-handled';
                    }
                }
                return 'not-handled';
            }
            return 'not-handled';
        };

        _this.handleKeyCommand = function (command, editorState) {
            var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
            if (newState) {
                _this.onChange(newState);
                return 'handled';
            }
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                if (command === 'delete' || command === 'backspace') {
                    var contentState = editorState.getCurrentContent();
                    var deletedState = _draftJs.EditorState.push(editorState, _draftJs.Modifier.removeRange(contentState, editorState.getSelection(), 'forward'), 'remove-range');
                    var unstyledState = _draftJs.EditorState.push(deletedState, _draftJs.Modifier.setBlockType(deletedState.getCurrentContent(), editorState.getSelection(), 'unstyled'), 'change-block-type');
                    if (unstyledState) {
                        _this.onChange(unstyledState);
                        return 'handled';
                    }
                }
            }
            return 'not-handled';
        };

        _this.handleBeforeInput = function (chars, editorState) {
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                return 'handled';
            }
            return 'not-handled';
        };

        _this.handlePastedText = function (text, html, editorState) {
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                return 'handled';
            }
            return 'not-handled';
        };

        _this.state = {
            editorState: undefined
        };
        return _this;
    }

    (0, _createClass3.default)(DraftEditor, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var editorState = this.createEditorState();
            this.setState({
                editorState: editorState
            });
        }
        // trigger when editorState change

        // get EditorState

        // create default EditorState

        // change EditorState
        // changeEditorState: Function = (editorState) => {
        //     this.setState({
        //         editorState
        //     });
        // }
        // handle return key

        // key handle

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                placeholder = _props.placeholder,
                readOnly = _props.readOnly;
            var editorState = this.state.editorState;

            return _react2.default.createElement(
                'div',
                { className: 'rde-wrap' },
                !readOnly && _react2.default.createElement(_ToolBar2.default, {
                    currentState: editorState,
                    imageUploader: this.props.imageUploader,
                    changeState: this.onChange,
                    customBlockConfig: this.props.customBlockConfig,
                    ref: function ref(_ref) {
                        _this2.wrapper = _ref;
                    }
                }),
                _react2.default.createElement(_draftJs.Editor, {
                    onTab: this.onTab,
                    blockRendererFn: (0, _blocks2.default)(this.onChange, this.getEditorState, this.props.customBlockConfig, this.props.imageUploader),
                    blockStyleFn: _utils.blockStyleFunc,
                    editorState: editorState,
                    onChange: this.onChange,
                    readOnly: readOnly,
                    handleKeyCommand: this.handleKeyCommand,
                    handleBeforeInput: this.handleBeforeInput,
                    handlePastedText: this.handlePastedText,
                    handleReturn: this.handleReturn,
                    placeholder: placeholder,
                    ref: function ref(_ref2) {
                        _this2.editor = _ref2;
                    }
                })
            );
        }
    }]);
    return DraftEditor;
}(_react.Component), _class.propTypes = {
    imageUploader: _propTypes2.default.func.isRequired,
    initContentState: _propTypes2.default.object,
    customBlockConfig: _propTypes2.default.object,
    readOnly: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    placeholder: _propTypes2.default.string
}, _temp);
exports.default = DraftEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/components/Editor/index.js
// module id = 64
// module chunks = 0